"use strict";

document.querySelectorAll(".menu-item-has-children").forEach((element) => {
  element.addEventListener("mouseover", (event) => {
    event.target.classList.add("active");
    element.children[1].classList.add("active");
  });
  element.addEventListener("mouseleave", (event) => {
    event.target.classList.remove("active");
    element.children[1].classList.remove("active");
  });
  element.addEventListener("touchend", (event) => {
    event.target.classList.toggle("active");
    element.children[1].classList.toggle("active");
  });
});

document.querySelector(".hamburger-Menu").addEventListener("click", (event) => {
  event.target.classList.toggle("active");
  document.querySelector(".header__navigation").classList.toggle("active");
});
